import React from 'react';
import { Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { removeHyphensAndCapitalize, imgUrlGenerate } from '../../../helpers';
import { header, headerItem } from './Header.module.css';
import { HOME_PAGE_LINK, OUR_COFFEE_LINK, FOR_YOUR_PLEASURE_LINK, CONTACT_US_LINK } from '../../../utils/constants';

const Header = () => (
  <Row>
    <Col lg={{ size: 6 }}>
      <header>
        <ul className={header}>
          {[HOME_PAGE_LINK, OUR_COFFEE_LINK, FOR_YOUR_PLEASURE_LINK, CONTACT_US_LINK].map(url => {
            if (url === HOME_PAGE_LINK) {
              return (
                <li className={headerItem} key={url}>
                  <Link to={`${url}`}>
                    <img src={imgUrlGenerate(`Logo.svg`)} alt='logo' />
                  </Link>
                </li>
              )
            }
            return (
              <li className={headerItem} key={url}>
                <Link to={`/${url}/`}>{removeHyphensAndCapitalize(url)}</Link>
              </li>
            )
          })}
        </ul>
      </header>
    </Col>
  </Row>
)

export default Header